<template>
  <nav class="navbar navbar-expand-md fixed-top navbar-light bg-white">
    <div class="container-fluid p-0">
      <div class="d-none d-md-block brand-indent">

      </div>

      <router-link :to="{ name: user ? 'home': 'login' }" class="navbar-brand">
        <img alt="Sandoz" class="img-fluid brand-logo" src="/images/sandoz.svg">
      </router-link>

      <div>
        <fa class="ml-2" icon="bars" size="lg" @click="toggleSidebar"/>
      </div>

      <div id="navbarToggler" class="collapse navbar-collapse">
        <div class="navbar-nav ml-auto mt-2 mt-lg-0">
          <locale-dropdown/>
        </div>
        <ul class="navbar-nav">
          <template v-if="!user">
            <li class="nav-item">
              <router-link :to="{ name: 'login' }" active-class="active" class="nav-link">
                {{ $t('core.login') }}
              </router-link>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import LocaleDropdown from './LocaleDropdown'
import Search from './Search'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'o-secondary-navbar',
  data: () => ({
    appName: window.config.appName
  }),

  computed: mapGetters({
    user: 'auth/user'
  }),

  components: {
    LocaleDropdown,
    Search,
    FontAwesomeIcon
  },

  methods: {
    async logout () {
      // Log out the user.
      await this.$store.dispatch('auth/logout')

      // Redirect to login.
      this.$router.push({ name: 'login' })
    },
    toggleSidebar () {
      this.$emit('toggle-sidebar')
    }
  }
}
</script>
